import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, Button } from '@mui/material';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import moment from 'moment';

const DatePickerDialog = ({ open, onClose, onDateSelect }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleSelect = (date) => {
    setSelectedDate(date);
  };

  const today = new Date();
  const oneWeekLater = new Date();
  oneWeekLater.setDate(today.getDate() + 7);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onDateSelect(selectedDate);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className='bg-teal-500 text-white font-semibold p-2'>
        <h2 className='text-white text-lg opacity-70'>
          {moment(selectedDate).format('yy')}
        </h2>
        <h2 className='text-white text-3xl'>
          {selectedDate ? moment(selectedDate).format('ddd, MMM D') : moment().format('ddd, MMM D')}
        </h2>
      </div>
      <DialogContent>
        <div>
          <DayPicker
            mode="single"
            disabled={[{ before: today }, { after: oneWeekLater }]}
            selected={selectedDate}
            onSelect={handleSelect}
            modifiers={{ selected: selectedDate }}
            modifiersClassNames={{
              selected: 'bg-teal-500 text-white rounded-full w-8 h-8 ',
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOk} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatePickerDialog;
